<template>
  <!--专题管理-->
  <div class="zhuanti_cont">
    <el-collapse v-model="activeNames">
      <!--1.专题基本信息-->
      <el-collapse-item title="专题基本信息" name="1">
        <el-form   :model="zhuantibox" label-width="130px" :rules="rules" ref="zhuantibox">
          <el-form-item label="会议名称1">
            <el-input v-model="zhuantibox.name"></el-input>
          </el-form-item>
          <el-form-item label="会议名称2">
            <el-input v-model="zhuantibox.name1" ></el-input>
          </el-form-item>
          <el-form-item label="名称1">
            <el-input v-model="zhuantibox.topDescribe"></el-input>
          </el-form-item>
          <el-form-item label="名称2">
            <el-input v-model="zhuantibox.topDescribe1"></el-input>
          </el-form-item>
          <el-form-item label="模板">
            <el-select v-model="zhuantibox.templateId" placeholder="请选择模板">
              <el-option label="蓝色模板" value="1"></el-option>
              <el-option label="红色模板" value="2"></el-option>
              <el-option label="灰色模板" value="3"></el-option>
              <el-option label="鸣沙模板" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主题色号">
            <el-color-picker v-model="zhuantibox.color_number"></el-color-picker>
          </el-form-item>
        <!--  <el-form-item label="名称是否显示" prop="nameDisplay">
            <el-switch v-model="zhuantibox.nameDisplay" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>-->
          <el-form-item label="底部描述" prop="footDescribe">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" v-model="zhuantibox.footDescribe"></el-input>
          </el-form-item>
          <el-form-item label="LOGO">
            <el-upload class="avatar-uploader" action="" :show-file-list="false"  :http-request="getFile" auto-upload  list-type="picture-card" style="overflow:hidden;">
              <img :src="zhuantibox.logo" style="width:100%;height:100%;" v-if="zhuantibox.logo != ''">
              <i class="el-icon-plus"></i>
            </el-upload>
            <button  type="button"  class="layui-btn layui-btn-sm " v-if="zhuantibox.logo != ''" style="margin-left:30px;"  @click="removeImg('logo')">清除LOGO</button>
            <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度180px，宽度180px</p>
          </el-form-item>
          <el-form-item label="会议背景图">
            <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile2" auto-upload  list-type="picture-card"   style="overflow:hidden;" >
              <img :src="zhuantibox.background" style="width:100%;height:100%;" v-if="zhuantibox.background != ''">
              <i class="el-icon-plus"></i>
            </el-upload>
            <button  type="button"  class="layui-btn layui-btn-sm " v-if="zhuantibox.background != ''" style="margin-left:30px;"  @click="removeImg('background')">清除背景图</button>
            <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：宽度保持750px，高度不限</p>
          </el-form-item>
          <el-form-item label="顶部整图模式图">
            <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload  list-type="picture-card" :limit="1" style="overflow:hidden;">
              <img :src="zhuantibox.topImg" style="width:100%;height:100%;" v-if="zhuantibox.topImg != ''">
              <i class="el-icon-plus"></i>
            </el-upload>
            <button type="button" class="layui-btn layui-btn-sm " v-if="zhuantibox.topImg != ''" style="margin-left:30px;" @click="removeImg('topImg')">清除图片</button>
            <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：宽度保持750px，高度不限</p>
          </el-form-item>
        <div class="layui-card">
          <div class="layui-card-header">
            <button type="button" class="layui-btn layui-btn-sm btn_r" @click="addjbbox(1)">新增基本信息</button>
          </div>
          <div class="layui-card-body">
            <p style="font-size:12px;margin-top:7px;color:#606266">此表单为会议时间、会议地址、承办单位、主办单位等信息</p>
            <el-table border :data="jibentableData" style="width: 100%">
              <el-table-column type="index" align="center" label="序号" width="60">
              </el-table-column>
              <el-table-column  align="center" prop="index" sortable label="排序" width="90" style="text-align:center;" :formatter="formatter">
                <template slot-scope="scope">
                  <el-input  v-model="scope.row.index" class="padding_10"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" align="center" label="名称" width="180">
              </el-table-column>
              <el-table-column prop="info" label="内容">
              </el-table-column>
              <el-table-column align="center" label="操作" width="160">
                <template slot-scope="scope">
                  <el-button size="mini" @click="addjbbox(2,scope.$index)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="removejb(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
          <el-form-item style="text-align:center;">
            <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="submitForm('zhuantibox')">保存基本信息</button>
          </el-form-item>
      </el-form>
      </el-collapse-item>
      <el-collapse-item title="栏目信息" name="2">
        <zhuantilanmu :zhuantibox="zhuantibox"></zhuantilanmu>
      </el-collapse-item>
    </el-collapse>

<!--新增基本信息-->
<el-dialog title="编辑基本信息" :visible.sync="jibenDialog" :modal-append-to-body="false" :close-on-click-modal="false">
  <div class="addjiben_box">
    <el-form   :model="addjiben" label-width="130px" :rules="jbrules" ref="addjiben">
      <el-form-item label="名称" prop="name">
        <el-input v-model="addjiben.name"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="info">
        <el-input type="textarea" v-model="addjiben.info"></el-input>
      </el-form-item>
      <el-form-item style="text-align:center;">
        <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="addjbSubmit('addjiben')">保存</button>
      </el-form-item>
    </el-form>
  </div>
</el-dialog>


  </div>
</template>

<script>
  import zhuantilanmu from "@/pages/AnewMeeting/zhuantilanmu";
  export default {
    name: "zhuanti",
    data() {
      return {
        activeNames: ['1','2'],//版块开关
        zhuantibox:{
          conferenceId:'',
          confereId:'',
          logo:'',//顶部logo
          name:'',//会议名称1
          name1:'', //会议名称2
          topDescribe:'', //顶部描述
          topDescribe1:'', //顶部描述第二行
          footDescribe:'', //底部描述
          nameDisplay:'1', //名称是否显示，0：否，1：是。
          id:'', //编辑时，必填
          background:'', //背景图
          topImg:'', //顶部图片
          content:'', //json字符串
          templateId:'1', //模板ID
          color_number:null,//主题色号
        },
        rules: {
          name: [
            { required: true, message: '请填写会议名称1', trigger: 'blur' },
          ],
          name1: [
            { required: true, message: '请填写会议名称2', trigger: 'blur' },
          ],
          topDescribe: [
            { required: true, message: '请填写名称1', trigger: 'blur' },
          ],
          topDescribe1: [
            { required: true, message: '请填写名称2', trigger: 'blur' },
          ],
          templateId: [
            { required: true, message: '请选择模板', trigger: 'change' }
          ],
          nameDisplay: [
            { required: true, message: '请选择名称是否显示', trigger: 'change' }
          ],
          footDescribe: [
            { required: false, message: '请填写底部', trigger: 'blur' }
          ]
        },
        jibentableData: [
         /* {
          index: '1',
          name: '时间',
          info: '2021年12月12日（星期一）下午14:00-16:00'
          }*/
        ],//信息列表
        jibenDialog:false,//新增基本信息
        addjiben:{
          name:"",
          info:'',
          index:'',
        },
        jbrules: {
          name: [
            { required: true, message: '请填写会议名称1', trigger: 'blur' },
          ],
          info: [
            { required: false, message: '请填写底部', trigger: 'blur' }
          ]
        },
        lanmuData:[],//栏目列表
      };
    },
    components:{
      zhuantilanmu
    },
    created () {
      var _this = this;
      if(_this.$route.query.editId != null && _this.$route.query.editId != undefined){
        _this.zhuantibox.confereId =  _this.$route.query.editId;
        _this.zhuantibox.conferenceId =  _this.$route.query.editId;
        _this.getZTinfo();
      }
    },
    methods: {
      /*上传图片*/
      getBase64(file){  //把图片转成base64编码
        return new Promise(function(resolve,reject){
          let reader=new FileReader();
          let imgResult="";
          reader.readAsDataURL(file);
          reader.onload=function(){
            imgResult=reader.result;
          };
          reader.onerror=function(error){
            reject(error);
          };
          reader.onloadend=function(){
            resolve(imgResult);
          }
        })
      },
      uploadImg(option,type){
        var _this = this;
        var file = option.file;
        this.getBase64(file).then(res=>{
          // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
          let params = { base64:res};
          let url = _this.APIurl.API.api.up_baimg;
          _this
            .$postform(url, params)
            .then((res) => {
            if (parseInt(res.code) === 1)
            {
              _this.$message({
                message: "上传成功",
                type: "success",
                duration: 1000,
              });
              if(type == 'logo'){
                _this.zhuantibox.logo = res.posts[0].domain+'/'+res.posts[0].image;
              }
              if(type == 'back'){
                _this.zhuantibox.background =  res.posts[0].domain+'/'+res.posts[0].image;
              }
              if(type == 'top'){
                _this.zhuantibox.topImg = res.posts[0].domain+'/'+res.posts[0].image;
              }
            } else
            {
              _this.$message({
                message: res.msg,
                type: "warning",
                duration: 1000,
              });
            }
          }).catch((error) => {
            if (error == undefined)
            {
              layer.msg("仅支持上传图片");
            } else
            {
              _this.$message({
                message: error,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
      },
      //logo
      getFile(option){  //上传
        var _this = this;
        _this.uploadImg(option,'logo');
      },
      //背景图
      getFile2(option){  //上传
        var _this = this;
        _this.uploadImg(option,'back');
      },
      //顶部图
      getFile3(option){  //上传
        var _this = this;
        _this.uploadImg(option,'top');
      },
      //保存修改新增基本信息
      addjbSubmit(formName) {
        var _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(_this.addjiben.index === ''){
              _this.jibentableData.push({
                name:_this.addjiben.name,
                info:_this.addjiben.info,
                index:0
              });
            }else{
              _this.$set(_this.jibentableData,_this.addjiben.index,_this.addjiben);
            }
            _this.jibenDialog = false;
            _this.addjiben = {
              name:"",
              info:'',
              index:'',
            }
          } else {
            _this.$message({
              message: '请正确填写表单内容!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },
      //新增编辑基本信息
      addjbbox(type,index){
        var _this = this;
        console.log(index);
        if(type == 1){
          _this.addjiben.index = '';
        }else{
          _this.addjiben.name = _this.jibentableData[index].name;
          _this.addjiben.info = _this.jibentableData[index].info;
          _this.addjiben.index = index;
        }
        _this.jibenDialog = true;
      },
      removejb(index){
        var _this = this;
        _this.jibentableData.splice(index,1);
      },
      //清除背景图
      removeImg(type){
        var _this = this;
        if(type == 'background'){
          _this.zhuantibox.background = '';
        }
        if(type == 'topImg'){
          _this.zhuantibox.topImg = '';
        }
        if(type == 'logo'){
          _this.zhuantibox.logo = '';
        }

      },
      //获取专题基本信息
      getZTinfo(){
        var _this = this;
        var url = "/ac1/conference/sharePage/detail"
        var params = {
          id:_this.zhuantibox.confereId
        };
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            if(res.posts != ''){
              _this.zhuantibox = res.posts;
              _this.zhuantibox.nameDisplay = String(_this.zhuantibox.nameDisplay);
              _this.zhuantibox.templateId = String(_this.zhuantibox.templateId);
              if(res.posts.content != ''){
                _this.jibentableData = JSON.parse(res.posts.content);
              }
            }
          }
        })
      },
      //基本信息排序
      formatter(row, column) {
        console.log(row);
      },
      sortBy(i) {
        return function(a,b) {
          return a[i] - b[i] //  a[i] - b[i]为正序，倒叙为  b[i] - a[i]
        }
      },
      //提交基本信息表单
      submitForm(formName) {
        var _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/sharePage/save"
            var params = JSON.parse(JSON.stringify(_this.zhuantibox));
            if(_this.jibentableData.length > 0){
              var listbox = _this.jibentableData.sort(_this.sortBy("index"));
              params.content = JSON.stringify(listbox);
            }
            _this.$get(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.getZTinfo();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写表单内容!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },
    },

  };
</script>

<style lang="scss" scoped>
  .zhuanti_cont {
    padding: 0 20px;
    background-color: #FFF;
    .meeting-the-basic{
      font-weight: bold;
      margin-left: 10px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .tree {
      padding: 20px 10px;
      background-color: white;
      margin-bottom: 20px;
    }
     .layui-form-label {
      width: 110px;
    }
     .info .layui-form-label {
      width: 110px;
    }
     .layui-form-label {
      padding: 9px 0;
    }
     .layui-input-block {
      margin-left: 120px;
    }
    .btn_r{
      float: right;
    }
     #payment .payment {
      width: 155px;
      margin-right: 10px;
    }
     #hotel .hotel {
      width: 90%;
    }
     .required {
      color: red;
      font-size: 150%;
    }
    #dining .layui-form-label {
      width: 110px !important;
    }
    #lanmuData{
      input{
        width: 40px;
        text-align: center;
        border: 1px solid #EBEEF5;
      }
    }
    .padding_10{
      padding: 0 5px;
      text-align: center;
    }
    @media screen and (min-width: 320px) and (max-width: 750px) {
       .button {
        margin-top: 10px;
      }
       .left {
        margin-left: 30px;
      }
       .mar-left {
        margin-left: 110px;
      }
       .edit {
        margin-left: 10px;
        margin-bottom: 10px;
      }

      .invoice {
        margin-top: 0px;
        margin-left: 10px;
      }
      .a {
        width: 60px;
      }
    }
  }
</style>
